var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.013,
    height: 30,
    viewBox: "0 0 24.013 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag",
    transform: "translate(-48.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1950",
    "data-name": "Trazado 1950",
    d: "M72.806,25.933,71.089,6.589a.827.827,0,0,0-.822-.755H66.733a5.927,5.927,0,0,0-11.853,0H51.346a.822.822,0,0,0-.822.755L48.806,25.933c0,.025-.006.049-.006.074A4.275,4.275,0,0,0,53.3,30H68.309a4.275,4.275,0,0,0,4.5-3.994A.3.3,0,0,0,72.806,25.933Zm-12-24.276a4.274,4.274,0,0,1,4.27,4.178h-8.54A4.274,4.274,0,0,1,60.806,1.656Zm7.5,26.687H53.3a2.643,2.643,0,0,1-2.847-2.3L52.1,7.5h2.773v2.515a.828.828,0,1,0,1.656,0V7.5h8.546v2.515a.828.828,0,1,0,1.656,0V7.5h2.773l1.65,18.546A2.647,2.647,0,0,1,68.309,28.344Z",
    fill: "#393338"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.c63fa242484d6ccf33ef6361178c45a2.svg";
export { ForwardRef as ReactComponent };